export default __webpack_public_path__ + "static/media/whatsapp.98c088d3.svg";